import { selectAcresAvailable } from "../selectors/selectAcresAvailable";
import { createPathFocusBuildingMaxLevel } from "./createPathFocusBuildingMaxLevel";
/**
 * This path is called when all acres on farm have production finished.
 * Since we already check for all acres production finished before calling this.
 * We do not need that check here.
 */
export var pathSelectAcreProductionDoneMaxLevelUseHumus = function (action, state$, deps) {
    return createPathFocusBuildingMaxLevel(function () {
        return selectAcresAvailable(state$.value);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathSelectAcreProductionDoneMaxLevelUseHumus.ts
// module id = 2393
// module chunks = 3